<template lang="pug">
  #QRCode.container-width
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
    .container-width
      .text-center(
        v-if="data"
      )
        .mb-3.mt-3
          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
            :profileUrl="data.picture_url",
            :style="{ 'width': '100px', 'height': '100px', 'z-index': 3}"
          )
        h3.mb-3.font-weight-bold {{ data.chinese_last_name }}{{ data.chinese_first_name }}
        .advisor_store
          i.advisor_store_icon.icon-icon_location
          span.font-weight-normal 櫃點：{{ data.stores[0].store_dealer_title }}/{{ data.stores[0].title }}
        vue-qr(
          v-if="data",
          :text="`${ bindSaRouter }?sa_id=${ data.id ? data.id : null }&store_id=${ nowSelectStore.id ? nowSelectStore.id : null }`"
          style='width:220px'
        )
        .btn_wrap
          .btn-custom.btn-b(@click.stop.prevent="shareUrl")
            span 分享連結
        .underThanTwoStore.d-none(
          v-if="data.stores.length <= 2"
        )
          b-row(
            :no-gutters="data.stores.length === 2"
          )
            b-col(
              :cols="data.stores.length === 2 ? 6 : 12",
              v-for="(store,index) in data.stores",
              :key="store.id",
              :class="{ 'text-right pr-1': data.stores.length === 2 && index === 0, 'text-left pl-1': data.stores.length === 2 && index === 1 }"
            )
              b-button(
                variant="primary",
                @click="changeQRCodeHandler(store)"
              ) {{ store.store_dealer_title }}/{{ store.title }}
        .moreThanTwoStore.d-none
          b-select(
            v-if="data.stores.length > 2"
            :option="stores",
            v-model="nowSelectStore"
          )
            b-form-select-option(
              v-for="(store,index) in data.stores",
              :key="store",
              :value="store"
            ) {{ store.store_dealer_title }}/{{ store.title }}
</template>

<script>
import { mapState } from 'vuex';
import VueQr from 'vue-qr';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'QRCodeIndex',
  components: {
    ProfilePhotoSticker,
    VueQr
  },
  data() {
    return {
      nowSelectStore: null
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sa_qr_code/getProfileHandler')
      .then(() => {
        vm.nowSelectStore = vm.data.stores[0] ? vm.data.stores[0] : null;
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    changeQRCodeHandler(store) {
      const vm = this;
      if (store === vm.nowSelectStore) return;
      vm.nowSelectStore = store;
    },
    routerBack() {
      this.$router.back();
    },
    shareUrl() {
      const vm = this;
      const route = vm.bindSaRouter;
      const url = encodeURIComponent(`${route}?sa_id=${ vm.data.id ? vm.data.id : null }&store_id=${ vm.nowSelectStore.id ? vm.nowSelectStore.id : null}`);
      window.location = `http://line.naver.jp/R/msg/text/?親愛的顧客您好~為提供更專屬於您的服務，請您點下方連結就可以跟我在LINE官方帳號互動喔!%0D%0A${url}`;
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.sa_qr_code.data
    }),
    bindSaRouter() {
      if (process.env.NODE_ENV === 'development') {
        return `${process.env.VUE_APP_DOMAIN}:${process.env.VUE_APP_DEV_PORT}/member/bind-sa`;
      }
      return `${process.env.VUE_APP_DOMAIN}/member/bind-sa`;
    }
  }
};
</script>

<style scoped>
  .container-width {
    padding-top: 30px;
  }
  .top {
    background-color: #000 !important;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 8rem;
  }

  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  #header_back {
    font-size: 1.7rem;
    padding: 0.5rem;
    position: absolute;
    top: 3%;
    left: 1.6rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: #fff !important;
    z-index: 15;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-icon_arrowLeft {
    top: 0;
    left: 5px;
  }
  .icon-icon_arrowLeft:before {
    content: "\e907";
  }

  .icon-icon_location:before {
    content: "\e909";
  }

  .btn_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 2rem;
  }

  .btn-custom {
    background-color: $remind !important;
    color: #000 !important;
    border-radius: 9487px;
    font-size: 1.1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.15rem 0.15rem 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0.15rem 0.15rem 0 rgba(0, 0, 0, 0.2);
    border: 0.2rem solid #000;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .btn-b {
    width: 100%;
    padding: 0.2rem 0;
  }
</style>
